import {
	Bootstrap,
	type BootstrapProps,
	Scripts,
	type ScriptsProps,
} from "@tiendanube/nube-sdk-shared";
import type { Prettify } from "@tiendanube/nube-sdk-types";

export type LoaderProps = Prettify<ScriptsProps & BootstrapProps> & {
	disableInlineStyle?: boolean;
	css?: string;
};

export function Loader({
	withTelemetry,
	hostId,
	initialState,
	apps,
	disableInlineStyle = false,
	css,
}: LoaderProps) {
	return (
		<>
			<Bootstrap hostId={hostId} initialState={initialState} apps={apps} />
			<Scripts withTelemetry={withTelemetry} />
			{!disableInlineStyle && css && (
				<style
					id="nube-sdk-base-styles"
					// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
					dangerouslySetInnerHTML={{ __html: css }}
				/>
			)}
		</>
	);
}
